module.exports = __webpack_public_path__ + "static/media/ftu-bodyfat.27df1b64.svg";